import { readAnalyticsAllowedForGtagBootstrap } from './consent-storage';

/**
 * Install `gtag` queue + consent defaults before Angular boot so nothing runs as granted without local consent.
 */
export function installGtagConsentDefaults(measurementId: string | undefined): void {
  if (!measurementId || typeof globalThis.window === 'undefined') {
    return;
  }

  const w = globalThis.window;
  w.dataLayer = w.dataLayer ?? [];
  const gtagFn =
    w.gtag ??
    ((...args: unknown[]) => {
      w.dataLayer.push(args);
    });
  w.gtag = gtagFn;

  const granted = readAnalyticsAllowedForGtagBootstrap();
  gtagFn('consent', 'default', {
    analytics_storage: granted ? 'granted' : 'denied',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    functionality_storage: 'granted',
    personalization_storage: 'denied',
    security_storage: 'granted',
  });
}
